import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Role } from '../constants';

@Pipe({
    name: 'joinRoles',
    standalone: false
})
export class RolesJoinPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: Role[]): string {
    if (!value || !Array.isArray(value)) {
      return '';
    }

    return value
      .map((role: Role) => this.translate.instant('administration.user.item.userRoles.roles.' + role))
      .join(', ');
  }
}
